const GA_ID = import.meta.env.VITE_GA4_MEASUREMENT_ID as string | undefined;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

let loaded = false;
let lastTrackedPath: string | null = null;

// No cookie-consent gate — Australia doesn't require GDPR-style opt-in, so GA4
// loads on startup with anonymised IP and the privacy policy discloses it.
// Idempotent: safe to call more than once.
export function loadAnalytics() {
  if (loaded || typeof window === "undefined" || !GA_ID) return;
  loaded = true;

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  const gtag: (...args: unknown[]) => void = (...args) => {
    window.dataLayer!.push(args);
  };
  window.gtag = gtag;
  gtag("js", new Date());
  // send_page_view:false — PageviewTracker owns all pageviews so we don't double-count.
  gtag("config", GA_ID, { anonymize_ip: true, send_page_view: false });

  // Fire the initial pageview ourselves; PageviewTracker's first effect may have
  // run before `loaded` flipped true and short-circuited.
  trackPageview(window.location.pathname + window.location.search);
}

export function trackPageview(path: string) {
  if (!loaded || !GA_ID || typeof window === "undefined" || !window.gtag) return;
  // StrictMode re-mounts effects in dev — dedupe by path so we don't double-count.
  if (path === lastTrackedPath) return;
  lastTrackedPath = path;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}
